<template>
  <div class="requestPreview">
    <form>
      <div id= "modal" class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Pedido de Venda</h5>
            <span id="close" class="close" @click="closeModal()">&times;</span>
          </div>
          <div class="modal-body">
            <div class="row ml-1 mr-1 p-2">
              <div class="font-weight-bold">
                <label class="d-block">Pedido emitido em: {{ propsRequest.date.slice(8, 10) }}/{{ propsRequest.date.slice(5, 7)}}/{{ propsRequest.date.slice(0, 4)}} as: {{ propsRequest.time }}</label>
                <label class="d-block">Cliente: {{ propsRequest.nameUser }}</label>
                <label class="d-block">E-mail: {{ propsRequest.emailUser }}</label>
              </div>
            </div>
            <div class="row ml-1 mr-1">
              <div class="form-group col-12">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Produto</th>
                      <th scope="col" class="text-right">Quant</th>
                      <th scope="col" class="text-right">Valor</th>
                      <th scope="col" class="text-right">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in propsRequest.items" :key="index">
                      <td>{{ item.name }}</td>
                      <td class="text-right">{{ item.quantity }}</td>
                      <td class="text-right"><span v-money-format="item.price"/></td>
                      <td class="text-right"><span v-money-format="item.total"/></td>
                    </tr>
                  </tbody>
                  <tfoot class="font-weight-bold">
                    <td colspan="3" class="text-right">Total</td>
                    <td class="text-right" v-money-format="propsRequest.total"></td>
                    <td></td>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="row ml-1 mr-1 p-2">
              <label class="font-weight-bold">Forma de Entrega: {{ propsRequest.formDelivery }}</label>
            </div>
            <div class="row ml-1 mr-1 p-2">
              <label>Observações: {{ propsRequest.observation }}</label>
            </div>
          </div>
          <div id= "modal-footer" class="modal-footer">
            <button class="btn btn-secondary" type="button" @click="closeModal()">Sair</button>
            <button class="btn btn-success" type="button" @click="printRequest()">Imprimir</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'RequestPreview',
  props: {
    propsRequest: {}
  },
  methods: {
    closeModal () {
      this.$emit('closePreview')
    },
    printRequest () {
      document.querySelector('#modal').className = ''
      document.querySelector('#modal-footer').className = 'print'
      document.querySelector('#close').className = 'print'
      print()
      document.querySelector('#modal').className = 'modal-dialog modal-dialog-scrollable modal-lg'
      document.querySelector('#modal-footer').className = 'modal-footer'
      document.querySelector('#close').className = 'close'
    }
  },
  mounted () {
    // Fecha o Menu Para Resolver problema de atualização no Crhome
    const menu = document.querySelector('.menu')
    menu.classList.add('menu-close')
    // Fecha o nets
    const nets = document.querySelector('.nets')
    nets.classList.add('nets-close')
    // Fecha o header-filter
    const headerFilter = document.querySelector('.header-filter')
    headerFilter.classList.add('header-filter-close')
    // Fecha o form
    const form = document.querySelector('.form')
    form.classList.add('form-close')
  },

  beforeDestroy () {
    // Mostra o menu
    const menu = document.querySelector('.menu')
    menu.classList.remove('menu-close')
    // Mostra o nets
    const nets = document.querySelector('.nets')
    nets.classList.remove('nets-close')
    // Mostra o header-filter
    const headerFilter = document.querySelector('.header-filter')
    headerFilter.classList.remove('header-filter-close')
    // Abre o form
    const form = document.querySelector('.form')
    form.classList.remove('form-close')
  }
}
</script>

<style lang="scss" scoped>
  @page {
      size: auto;
      margin: 0;
  }
  .requestPreview {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1000;
    form {
      .close {
        &:hover {
          color: #000;
          cursor: pointer;
        }
      }
    }
    .row {
      border: 1px solid grey;
    }
    .print {
      display: none;
    }
  }

</style>
